module.exports = __webpack_public_path__ + "img/gallery05.ea91838b.jpg";